export const leftArrow = require('../assets/leftArrow.png');
export const leftArrow1 = require('../assets/leftArrow1.png');
export const cancel = require('../assets/cancel.png');
export const radioActive = require('../assets/radio_active.png');
export const radioUnactive = require('../assets/radio_unactive.png');
export const deleteIcon = require('../assets/delete.png');
export const hospital = require('../assets/hospital.png')
export const patient = require('../assets/patient.png')
export const selectedBox = require('../assets/activeImage.png')
export const unSelectedBox = require('../assets/inActive.png');
export const homeImg = require("../assets/home.png");
export const menu = require('../assets/menuImg.png');
export const bell = require('../assets/bell.png');
export const person = require('../assets/person.jpg');
export const manifacImg = require('../assets/manifac_img.png');
export const rightArrow = require('../assets/rightArrow.png');
export const searchIcon = require('../assets/searchIcon.png');
export const search = require('../assets/search.png');
export const cross = require('../assets/cross.png');
export const filterIcon = require('../assets/filtericon.png');
export const dummyMaterial = require('../assets/dummyMaterial.png');
export const delete2 = require('../assets/delete2.png');
export const material2 = require('../assets/material2.png');
export const downArrow = require("../assets/DownArrow1.png");
export const chat = require("../assets/message.png");
export const newDownArrow = require("../assets/downArrowImg.png");
export const upDownArrow = require("../assets/upDownImg.png");
export const boxImg = require("../assets/checkbox.png");
export const BarCodeImg = require("../assets/BarCodeImg.png");
export const setting = require("../assets/Settings.png");
export const personImg = require("../assets/personImg.png");
export const greenImg = require("../assets/greenImg.png");
export const redImg = require("../assets/redImg.png");
export const writeCheckBox = require("../assets/writeCheckBox.png");
export const editIcon =  require("../assets/editIcon.png");
export const personImg1 = require("../assets/PersonImg1.png");
export const bitmap = require("../assets/bitmap.png");
export const backIcon = require("../assets/backIcon.png");
export const requestImg = require("../assets/bitmap.png");
export const homeDesktop = require('../assets/homeDesktop.png')
export const userDesktop = require('../assets/userDesktop.png')
export const plusDesktop = require('../assets/plusDesktop.png')
export const hospitalDesktop = require('../assets/hospitalDesktop.png')
export const calendarDesktop = require('../assets/calendarDesktop.png')
export const tracking = require('../assets/tracking.png')
export const navigationDesktop = require('../assets/navigationDesktop.png')
export const personDesktop = require('../assets/personDesktop.png')
export const bellDesktop = require('../assets/bellDesktop.png')
export const logout2 = require('../assets/logout2.png')
export const logout = require('../assets/logout.png')
export const homeIcon = require('../assets/homeIcon.png')
export const personsmall = require('../assets/personsmall.png')
export const invite = require('../assets/invite.png')
export const plus = require('../assets/plus.png')
export const cameraDesktop = require('../assets/cameraDesktop.png')
export const validateNewManager = require('../assets/validateNewManager.png')
export const userIcon = require('../assets/userIcon.png')
export const hospitalCopy = require('../assets/hospital copy.png')
export const calendar = require('../assets/calendar.png')
export const illustrationRegister = require('../assets/illustration-register-copy@3x.png')
export const add = require('../assets/add.png')
export const chatIconRed = require('../assets/chatIconRed.png')
export const messageIcon = require('../assets/messageIcon.png')
export const chatIcon = require('../assets/chatIcon.png')
export const addCopy = require('../assets/add copy.png')
export const upload = require('../assets/upload.png')
export const book = require('../assets/book.png')
export const validate = require('../assets/validate.png')
export const shopping = require('../assets/shopping.png')
export const avatarChat1 = require('../assets/avatar-chat1.png')
export const patientFemale = require('../assets/patient_female.png')
export const upmed = require('../assets/upmed.png')
export const patientMale = require('../assets/patient_male.png')
export const rectangle = require('../assets/rectangle.png')
